import React, { useEffect, useState } from "react";

interface props {
  id: any;
  idCnpj?:any;
  value: any;
  label: any;
  setCustomerData: any;
  isInvalid?: any;
  setIsInvalid?: any;
}

const InputNumber: React.FC<props> = ({ id, idCnpj, value, label, setCustomerData, isInvalid, setIsInvalid }) => {
  const [maskedValue, setMaskedValue] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    const inputValue = value.replace(/\D/g, "")
    setCustomerData((prevForm: any) => ({
      ...prevForm,
      [id]: inputValue,
    }));

    setIsInvalid?.((prevForm: any) => ({
      ...prevForm,
      [id]: false,
    }));

    setMaskedValue(inputValue)
  }

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target

    if (value.length == 0) {
      setIsInvalid?.((prevForm: any) => ({
        ...prevForm,
        [id]: true,
      }));
    }
  }

  useEffect(() => {
    if (!maskedValue) {
      setMaskedValue(value)
    }
  }, [value])

  return (
    <div className="col-md-3">
      <label>{label}</label>
      <input
        id={id}
        className={`form-control ${isInvalid?.numero ? 'is-invalid' : ''}`}
        type="text"
        value={maskedValue}
        disabled={idCnpj ? true : false}
        onChange={handleChange}
        placeholder="Número"
        onBlur={handleBlur}
      />
      <p className="invalid-feedback">Insira um N°</p>
    </div>
  )
}

export default InputNumber